// URLs
export const URL_LOGIN = "/login";
export const URL_ONEPASS_LANDING = "/onepass";
export const URL_ONEPASS_TERMS_AND_CONDITIONS = "/onepass-terms";
export const URL_ONEPASS_OAUTH_REDIRECT = "/oauth_redirect/onepass";
export const URL_ONEPASS_SUBSCRIBE = "/onepass/subscribe";
export const URL_ONEPASS_CONSENT = "/onepass-consent";
export const URL_ONEPASS_SHOP = "/shop/onepass";
export const URL_ONEPASS_MANAGEMENT = "/my-account/onepass-subscription";
export const URL_ONEPASS_HELP =
  "https://help.catch.com.au/s/articles?catName=OnePass";

// Analytics
export const DEFAULT_CLUB_CATCH_EVENT_ID = 3;
export const DEFAULT_CATCH_SELLER_ID = 1;

// Query Params
export const ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY =
  "onepass-migration-status";
export const ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY = "double-sub";
export const ONEPASS_LINK_QUERY_PARAM_KEY = "link-onepass";
export const ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY = "showmessage";

// Others
export const HOTLINE_ONEPASS = "1300 222 824";
export const DEFAULT_FREE_TRIAL_DAYS = 30;
export const ONEPASS_MONTHLY_PRICE = 400;
export const ONEPASS_YEARLY_PRICE = 4000;

export * from "./experiments";
